import {FaFacebookF, FaInstagram, FaLinkedin} from "react-icons/fa6";
import {YoutubeOutlined} from "@ant-design/icons";
import React from "react";

const socialMedia = [{icon: <FaFacebookF/>, href: "https://www.facebook.com/share/1Bes3JcxT1/"}, {
    icon: <FaLinkedin/>,
    href: "#"
}, {icon: <YoutubeOutlined/>, href: "#"}, {icon: <FaInstagram/>, href: "#"}];
export default socialMedia;